<template>
    <div id="modal-proj-note" class="modal fade" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <!-- <div class="modal-header"> -->
                <!--     <h5><i class="fas fa-pen"></i>&nbsp;備考</h5> -->
                <!--     <p class="wrap-name"> -->
                <!--         <span class="intv-name"> -->
                <!--             <small>&nbsp;{{this.name}} </small> -->
                <!--         </span> -->
                <!--         <span><small>さん</small></span> -->
                <!--     </p> -->
                <!--     <button class="close" type="button" @click="addNote"> -->
                <!--         <span aria-hidden="true">&times;</span> -->
                <!--     </button> -->
                <!-- </div> -->
                <div class="modal-body">
                    <small><span class="text-muted">{{this.noteLength}}/500</span></small>
                    <textarea v-model.trim="note" class="form-control" rows="7" maxlength="500" spellcheck=false :placeholder="plhoder"></textarea>
                </div>
                <div class="modal-footer justify-content-center">
                    <button class="btn btn-primary" type="button" @click="addNote">
                        &nbsp;&nbsp;閉じる&nbsp;&nbsp;
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                note: "",
                noteHist: "",
                id: "",
            }
        },
        watch: {
            getCmpProjNoteStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.$store.dispatch('reflectList', this.getCmpProjNoted.data)
                    this.hideThis()
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            plhoder () {
                return "必要に応じて記入してください。"
            },
            updateFlg () {
                return this.note != this.noteHist
            },
            noteLength () {
                return this.note ? this.note.length : '0'
            },
            ...mapGetters(['getCmpProjNoted', 'getCmpProjNoteStatus'])
        },
        methods: {
            addNote () {
                if (this.updateFlg) {
                    this.$store.dispatch('cmpProjNote', {
                        note: this.note,
                        id: this.id,
                    })
                } else {
                    this.hideThis()
                }
            },
            hideThis () {
                $('#modal-proj-note').modal('hide')
            },
            openThis (item) {
                this.note = item.sys_note
                this.noteHist = item.sys_note
                this.id = item.id
                $('#modal-proj-note').modal('show')
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import '~stylus/base/mixins.styl'
    .wrap-name
        display: flex
        flex: 1
        white-space: nowrap
        overflow: hidden
        .intv-name
            ellipsis()
    .disabledBg
        background-color: #fff
</style>
